import { createApi } from "../../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";
import { useAppStore } from "../../../../../appStore";

export const handleSubmitNewGroup = async (
  submitObject: any,
  navigate: any,
  setBackdropLoadingScreenOn: any,
  setGroupAddedAlert: any
) => {
  const AxiosUI = createApi(``);
  const retryFunction = () => {
    handleSubmitNewGroup(
      submitObject,
      navigate,
      setBackdropLoadingScreenOn,
      setGroupAddedAlert
    );
  };
  setBackdropLoadingScreenOn(true);
  await AxiosUI.post(`/group/`, submitObject).then(
    () => {
      setGroupAddedAlert(true);
      AxiosUI.get(`group/?page_size=10000`).then(
        (response: AxiosResponse) => {
          localStorage.setItem(
            "parentGroups",
            JSON.stringify(response.data.results)
          );
          AxiosUI.get(`group/tree/?group_type=connector&page_size=1000`).then(
            (response: AxiosResponse) => {
              useAppStore.getState().setGroupTrees(response.data.results);
              setBackdropLoadingScreenOn(false);
            },
            (reason: AxiosError) => {
              universalAPIErrorHandler(reason, navigate, retryFunction, () => {
                setBackdropLoadingScreenOn(false);
              });
            }
          );
        },
        (reason: AxiosError) => {
          universalAPIErrorHandler(reason, navigate, retryFunction, () => {
            setBackdropLoadingScreenOn(false);
          });
        }
      );
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setBackdropLoadingScreenOn(false);
        alert("Error submitting new group, please try again");
      });
    }
  );
};
